import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class BrokerUserType {
  public readonly key = 'BrokerUserType';
  public readonly enrollTrackRole = EnrollTrackRole.Broker;
}
